import { Button, Icon } from '@servicetitan/anvil2';
import Launch from '@servicetitan/anvil2/assets/icons/material/round/launch.svg';
import { useProviderConfig } from '@servicetitan/financing-workflow-shared';

interface SelectPlanButtonProps {
    onClick: (isSelected: boolean) => void;
    planNumber: string;
    disabled?: boolean;
}

export const SelectPlanButton = ({ onClick, disabled = false }: SelectPlanButtonProps) => {
    const providerConfig = useProviderConfig();

    const isExternalPrequalEnabled = providerConfig.enableExternalPrequalification;

    const buttonText = isExternalPrequalEnabled ? 'Start Pre-Qualification' : 'Select Plan';

    const handleClick = () => {
        onClick(true);
    };

    return (
        <Button
            onClick={handleClick}
            appearance="primary"
            style={{ width: '100%' }}
            disabled={disabled}
        >
            {buttonText}
            {isExternalPrequalEnabled && <Icon inherit aria-hidden svg={Launch} />}
        </Button>
    );
};
